import type { ColorObject, RGB } from '@/types/app/color.type'

export const ASSET_COLORS = {
  BATTERY: 'var(--p-pink-500)',
  BATTERY_BANK: 'var(--help-color)',
  BIOGAS: 'hsl(83, 60%, 20%)',
  EFFICIENCY_SAVING: 'hsl(83, 66%, 50%)',
  ENERGY_CONSUMER: 'var(--p-teal-500)',
  GENERATOR: 'var(--warning-color)',
  HYDRO: 'hsl(83, 64%, 40%)',
  POWER_GRID: 'var(--primary-color)',
  SOLAR_PV: 'hsl(83, 66%, 44%)',
  WIND: 'hsl(83, 62%, 30%)',
}

export const CHART_COLORS = {
  BLUE: {
    BACKGROUND: '#E9F5FF',
    LINE: '#2385CC',
  },
  GREEN: {
    BACKGROUND: '#EFF8F0',
    LINE: '#357B23',
  },
  GREY: {
    BACKGROUND: '#F4F4F4',
    LINE: '#8A8A8A',
  },
  RED: {
    BACKGROUND: '#FFF2F2',
    LINE: '#FF5C5C',
  },
  YELLOW: {
    BACKGROUND: '#FFFCF3',
    LINE: '#FFCD29',
  },
  AMBER: {
    BACKGROUND: '#FFF5D8',
    LINE: '#FF8C00',
  },
  PURPLE: {
    BACKGROUND: '#F0E5FF',
    LINE: '#AF27CE',
  },
  ORANGE: {
    BACKGROUND: '#FFF5EB',
    LINE: '#FE8D00',
  },
  TEAL: {
    BACKGROUND: '#F0FDFB',
    LINE: '#14b8a6',
  },
  INDIGO: {
    BACKGROUND: '#EEF2FF',
    LINE: '#6366f1',
  },
  PINK: {
    BACKGROUND: '#FDF2F8',
    LINE: '#ec4899',
  },
}

export const CHART_COLORS_UNITS = {
  AMPERE: {
    BACKGROUND: 'rgba(54, 185, 204, 0.2)',
    HOVER: 'rgb(40, 138, 153)',
    LINE: 'rgb(54, 185, 204)',
  },
  BATTERY: {
    BACKGROUND: 'rgba(158, 206, 79, 0.2)',
    HOVER: 'rgb(144, 159, 28)',
    LINE: 'rgb(158, 206, 79)',
  },
  TEMPERATURE: {
    BACKGROUND: 'rgba(159, 126, 204, 0.2)',
    HOVER: 'rgb(128, 103, 163)',
    LINE: 'rgb(159, 126, 204)',
  },
  VOLTAGE: {
    BACKGROUND: 'rgba(211, 144, 18, 0.2)',
    HOVER: 'rgb(187, 127, 15)',
    LINE: 'rgb(211, 144, 18)',
  },
}

export const CHART_COLUMN_COLORS = {
  GREEN: 'rgb(134, 223, 179)' as RGB,
  RED: 'rgb(255, 99, 132)' as RGB,
}

export const TAG_COLORS = {
  BLUE: {
    BACKGROUND: '#D8EEFF',
    TEXT: '#2385CC',
  },
  BRIGHT_GREEN: {
    BACKGROUND: '#E9F5FF',
    TEXT: '#3bd415',
  },
  GREEN: {
    BACKGROUND: '#EFF8F0',
    TEXT: '#729B7D',
  },
  GREY: {
    BACKGROUND: '#F4F4F4',
    TEXT: '#8A8A8A',
  },
  RED: {
    BACKGROUND: '#F8EFEF',
    TEXT: '#FF7272',
  },
  YELLOW: {
    BACKGROUND: '#FFF5D8',
    TEXT: '#CCA423',
  },
  AMBER: {
    BACKGROUND: '#FFF5D8',
    TEXT: '#FF8C00',
  },
  PURPLE: {
    BACKGROUND: '#F0E5FF',
    TEXT: '#AF27CE',
  },
}

export const CHART_FILL_OPACITY = 0.16

export const SEVERITY_COLORS = {
  0: {
    background: 'hsl(198, 65%, 64%)',
    text: 'hsl(198, 65%, 48%)',
  },
  1: {
    background: 'hsl(43, 83%, 67%)',
    text: 'hsl(43, 83%, 53%)',
  },
  2: {
    background: 'hsl(25, 73%, 61%)',
    text: 'hsl(25, 73%, 59%)',
  },
  3: {
    background: 'hsl(10, 60%, 58%)',
    text: 'hsl(10, 60%, 62%)',
  },
  4: {
    background: 'hsl(0, 100%, 38%)',
    text: 'hsl(0, 100%, 38%)',
  },
}

export const SITE_CARD_TAG_OPACITY_HEX = '40'

export const NEUTRAL_TAG_COLOR: ColorObject = {
  background: '#EFF3F8',
  text: '#6C7E94',
}

export const UPLOADING_TAG_COLOR: ColorObject = {
  background: '#D8EEFF',
  text: '#2385CC',
}
